<template>
    <el-dialog :visible.sync="popupModal" width="530px" top="26vh"
        :title="actionType === 0 ? $t('client.site.add') : $t('client.site.edit')">
        <el-form :model="ruleForm" :rules="rules" ref="modalForm" label-width="140px" style="width: 472px;">
            <el-form-item :label="$t('client.site.type') + '：'" prop="type" @on-change="changeType">
                <el-select v-model="ruleForm.type" size="medium" :disabled="actionType === 1">
                    <el-option :value="0" :label="$t('client.site.region')"
                        v-if="areaEnable === 1 && allowAddArea"></el-option>
                    <el-option :value="1" :label="$t('client.site.site')"></el-option>
                </el-select>
            </el-form-item>

            <el-form-item :label="ruleForm.type === 0 ? $t('client.site.name') : $t('client.site.siteName') + '：'"
                key="name" prop="name">
                <el-input :placeholder="$t('common.inputplaceholder')" v-model="ruleForm.name" size="medium"
                    maxlength="32"></el-input>
            </el-form-item>

            <template v-if="ruleForm.type === 1">
                <el-form-item :label="$t('client.site.address') + '：'" prop="outletAddress">
                    <el-input :placeholder="$t('common.inputplaceholder')" v-model="ruleForm.outletAddress"
                        size="medium" maxlength="128"></el-input>
                </el-form-item>

                <el-form-item :label="$t('client.site.zone') + '：'" prop="timezoneId">
                    <el-select v-model="ruleForm.timezoneId" size="medium">
                        <el-option v-for="item in zoneList" :key="item.id" :value="item.id"
                            :label="item.timezonename"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item prop="dstEnable">
                    <el-checkbox :label="$t('client.site.dst')" v-model="ruleForm.dstEnable" :true-label="1"
                        :false-label="0"></el-checkbox>
                </el-form-item>

                <el-form-item :label="$t('client.site.start') + '：'" prop="begin.month" v-if="ruleForm.dstEnable">
                    <el-select v-model="ruleForm.begin.month" size="medium" style="width: 76px;margin-right: 5px;">
                        <el-option v-for="item in monthList" :key="item.label" :value="item.value"
                            :label="item.label"></el-option>
                    </el-select>
                    <el-select v-model="ruleForm.begin.weekInMonth" size="medium"
                        style="width: 76px;margin-right: 5px;">
                        <el-option v-for="item in indexList" :key="item.label" :value="item.value"
                            :label="item.label"></el-option>
                    </el-select>
                    <el-select v-model="ruleForm.begin.dayInWeek" size="medium" style="width: 76px;margin-right: 5px;">
                        <el-option v-for="item in weekList" :key="item.label" :value="item.value"
                            :label="item.label"></el-option>
                    </el-select>
                    <el-select v-model="ruleForm.begin.timeInDay" size="medium" style="width: 80px;">
                        <el-option v-for="item in timeList" :key="item.lable" :value="item.value"
                            :label="item.label"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item :label="$t('client.site.end') + '：'" prop="end.month" v-if="ruleForm.dstEnable">
                    <el-select v-model="ruleForm.end.month" size="medium" style="width: 76px;margin-right: 5px;">
                        <el-option v-for="item in monthList" :key="item.label" :value="item.value"
                            :label="item.label"></el-option>
                    </el-select>
                    <el-select v-model="ruleForm.end.weekInMonth" size="medium" style="width: 76px;margin-right: 5px;">
                        <el-option v-for="item in indexList" :key="item.label" :value="item.value"
                            :label="item.label"></el-option>
                    </el-select>
                    <el-select v-model="ruleForm.end.dayInWeek" size="medium" style="width: 76px;margin-right: 5px;">
                        <el-option v-for="item in weekList" :key="item.label" :value="item.value"
                            :label="item.label"></el-option>
                    </el-select>
                    <el-select v-model="ruleForm.end.timeInDay" size="medium" style="width: 80px;">
                        <el-option v-for="item in timeList" :key="item.lable" :value="item.value"
                            :label="item.label"></el-option>
                    </el-select>
                </el-form-item>

            </template>

            <el-form-item :label="$t('client.site.details') + '：'" prop="description">
                <el-input type="textarea" :placeholder="$t('common.inputplaceholder')" v-model="ruleForm.description"
                    maxlength="1000" show-word-limit></el-input>
            </el-form-item>

        </el-form>

        <span slot="footer" class="dialog-footer">
            <el-button @click="popupModal = false" class="sys-btn-default">{{ $t('common.cancel') }}</el-button>
            <el-button @click="saveData" type="primary">{{ $t('common.confirm') }}</el-button>
        </span>
    </el-dialog>
</template>

<script>
import Cookies from "js-cookie";
export default {
    data() {
        return {
            areaEnable: Number(Cookies.get("areaEnable")),
            allowAddArea: true,
            popupModal: false,
            ruleForm: {
                type: this.areaEnable === 1 ? 0 : 1,
                name: null,
                outletAddress: null,
                timezoneId: null,
                description: null,
                dstEnable: 0,
                begin: {
                    month: 1,
                    weekInMonth: 1,
                    dayInWeek: 1,
                    timeInDay: '0:00'
                },
                end: {
                    month: 1,
                    weekInMonth: 1,
                    dayInWeek: 1,
                    timeInDay: '0:00'
                },
            },
            zoneList: [],
            monthList: [{ label: 'Jan', value: 1 },
            { label: 'Feb', value: 2 },
            { label: 'Mar', value: 3 },
            { label: 'Apr', value: 4 },
            { label: 'May', value: 5 },
            { label: 'Jun', value: 6 },
            { label: 'Jul', value: 7 },
            { label: 'Aug', value: 8 },
            { label: 'Sep', value: 9 },
            { label: 'Oct', value: 10 },
            { label: 'Nov', value: 11 },
            { label: 'Dec', value: 12 }],
            indexList: [{ label: '1st', value: 1 },
            { label: '2nd', value: 2 },
            { label: '3rd', value: 3 },
            { label: '4th', value: 4 },
            { label: '5th', value: 5 }],
            weekList: [{ label: 'Mon', value: 1 },
            { label: 'Tue', value: 2 },
            { label: 'Wed', value: 3 },
            { label: 'Thur', value: 4 },
            { label: 'Fri', value: 5 },
            { label: 'Sat', value: 6 },
            { label: 'Sun', value: 7 }],
            timeList: [],
            rules: {
                name: [{ required: true, message: vm.$t('common.commontip'), trigger: 'blur' }],
                siteName: [{ required: true, message: vm.$t('common.commontip'), trigger: 'blur' }],
                timezoneId: [{ required: true, message: vm.$t('common.commontip') }],
                'begin.month': [{ required: true, message: vm.$t('common.commontip') }],
                'end.month': [{ required: true, message: vm.$t('common.commontip') }],
            },
            actionType: 0, // 0:add 1:update
            currentRowData: null,
            monitorId: Number(Cookies.get("monitorId")),
            curBrandId: null,
        }
    },

    created() {
        let data = [];
        for (let i = 0; i < 24; i++) {
            data.push({ label: i + ':00', value: i + ':00' });
        }
        this.timeList = data;
    },
    methods: {
        changeType() {
            this.$nextTick(() => {
                this.$refs.modalForm.resetFields();
            })
        },
        async open(type, row, curBrandId) {
            if (type === 0 && row.level === 3) {
                this.allowAddArea = false;
            } else {
                this.allowAddArea = true;
            }
            await this.areaGetAllTimezone();
            this.curBrandId = curBrandId;
            this.actionType = type;
            this.currentRowData = row;
            this.popupModal = true;
            this.$nextTick(() => {
                this.$refs.modalForm.resetFields();
                if (type === 1) {
                    this.ruleForm = {
                        type: row.type === "outlet" ? 1 : 0,
                        name: row.name,
                        outletAddress: row.outletAddress,
                        description: row.description,
                        timezoneId: row.timezoneId,
                        dstEnable: row.dstEnable,
                        begin: {
                            month: 1,
                            weekInMonth: 1,
                            dayInWeek: 1,
                            timeInDay: '0:00'
                        },
                        end: {
                            month: 1,
                            weekInMonth: 1,
                            dayInWeek: 1,
                            timeInDay: '0:00'
                        }
                    }
                    if (this.ruleForm.type === 1 && row.dstEnable === 1) {
                        this.ruleForm.begin = JSON.parse(row.dstTime).begin;
                        this.ruleForm.end = JSON.parse(row.dstTime).end;
                    }
                } else {
                    this.ruleForm = {
                        type: this.areaEnable === 1 && this.allowAddArea ? 0 : 1,
                        name: '',
                        outletAddress: '',
                        timezoneId: null,
                        description: '',
                        dstEnable: 0,
                        begin: {
                            month: 1,
                            weekInMonth: 1,
                            dayInWeek: 1,
                            timeInDay: '0:00'
                        },
                        end: {
                            month: 1,
                            weekInMonth: 1,
                            dayInWeek: 1,
                            timeInDay: '0:00'
                        }
                    }
                }
            });
        },
        saveData() {
            this.$refs.modalForm.validate(async (valid) => {
                if (!valid) {
                    return false;
                } else {
                    let params = {
                        description: this.ruleForm.description
                    }
                    let url = `${this.$Api.areaBrand}/${this.monitorId}/${this.curBrandId}`;
                    if (this.ruleForm.type === 1) {
                        url = `${this.$Api.areaOutlet}/${this.monitorId}`;
                        params.outletAddress = this.ruleForm.outletAddress;
                        params.outletName = this.ruleForm.name;
                        params.topBrandId = this.curBrandId;
                        params.checkStandardId = this.currentRowData.checkStandardId;
                        if (this.actionType === 1) {
                            params.outletId = this.currentRowData.id.substr(this.currentRowData.id.indexOf('_') + 1);
                            params.brandId = this.currentRowData.pId.substr(this.currentRowData.pId.indexOf('_') + 1);
                        } else {
                            params.brandId = this.currentRowData.id.substr(this.currentRowData.id.indexOf('_') + 1);
                        }
                        params.timezoneId = this.ruleForm.timezoneId;
                        params.dstEnable = this.ruleForm.dstEnable;
                        if (params.dstEnable === 1) {
                            params.dstTime = JSON.stringify({
                                begin: this.ruleForm.begin,
                                end: this.ruleForm.end
                            })
                        }
                    } else {
                        params.brandName = this.ruleForm.name;
                        if (this.actionType === 0) {
                            params.layer = this.currentRowData.level;
                            params.parentId = this.currentRowData.id.substr(
                                this.currentRowData.id.indexOf("_") + 1
                            );
                        } else {
                            params.id = this.currentRowData.id.substr(
                                this.currentRowData.id.indexOf("_") + 1
                            );
                            // params.layer = this.currentRowData.level;
                            params.parentId = this.currentRowData.pId.substr(
                                this.currentRowData.pId.indexOf("_") + 1
                            );
                        }
                    }
                    let res = {};
                    if (this.actionType === 0) {
                        let children = this.currentRowData.children;
                        if (children && children.length > 0) {
                            let type = this.ruleForm.type ? "outlet" : "brand";
                            if (type !== children[0].type) {
                                this.$message.error(this.$t('client.site.addValidate'));
                                return false;
                            }
                        }
                        res = await this.$Http.post(url, params);
                    } else {
                        res = await this.$Http.put(url, params);
                    }
                    if (res.success) {
                        this.popupModal = false;
                        this.$message.success(this.$t('common.successful'));
                        this.$emit("closeAddModal");
                    }
                }
            })
        },
        async areaGetAllTimezone() {
            let res = await this.$Http.get(`${this.$Api.areaGetAllTimezone}/${this.monitorId}`);
            if (res.success) {
                this.zoneList = res.result;
            }
        }
    }
}
</script>

<style scoped>
.el-select {
    width: 332px;
}
</style>